import React from 'react';
import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Row, Space } from 'antd';

import { ActionDefinition } from 'components/organism/crud/new-crud-modal';

export type CrudHeaderActions<T> = Omit<ActionDefinition<T>, 'canRender'> & { canRender: () => boolean };

type CrudHeaderProps<T> = {
  icon: React.ReactNode;
  title: React.ReactNode;
  total?: number;
  filterCounter?: number;
  actions: CrudHeaderActions<T>[];
  additionalActions?: () => React.ReactNode;
  onFilterClick?: () => void;
};

export function NewCrudHeader<T>(props: CrudHeaderProps<T>) {
  const renderActions = () => {
    return props.actions
      .filter((action) => action.canRender())
      .map((action) => (
        <Button
          key={action.key}
          danger={action.type === 'destructive'}
          type={action.type === 'primary' ? 'primary' : 'default'}
          icon={action.icon}
          onClick={() => {
            action.handler();
          }}
          disabled={action.disabled}
          loading={action.loading}
        >
          {action.title}
        </Button>
      ));
  };

  return (
    <Row className="crud-header" justify="space-between">
      <Col>
        <Space>
          <span className="crud-header__icon">{props.icon}</span>
          <span className="crud-header__title">{props.title}</span>
          {props.total && <span className="crud-header__counter">({props.total})</span>}
        </Space>
      </Col>
      <Col>
        <Space>
          {props.additionalActions && props.additionalActions()}
          {props.filterCounter !== undefined && (
            <Button
              className="crud-header__btn-filter"
              type="text"
              onClick={() => {
                if (props.onFilterClick) {
                  props.onFilterClick();
                }
              }}
            >
              <Badge count={props.filterCounter}>{props.filterCounter > 0 ? <FilterFilled /> : <FilterOutlined />}</Badge>
            </Button>
          )}
          {renderActions()}
        </Space>
      </Col>
    </Row>
  );
}
